import API from '@/views/Fdc/Apis/'
import Dayjs from 'dayjs'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Analysis > EQP Comparison
 * EQP Comparison
 */
export default {
  name: 'EqpComparison',
  mounted () {
  },
  watch: {
    /**
     * fromDate 변화 감지
     */
    fromDate () {
      this.toMinDate = this.fromDate
    },
    /**
     * toDate 변화 감지
     */
    toDate () {
      this.fromMaxDate = this.toDate
    },
    /**
     * checkedTreeNodes 변화 감지
     * @param {*} nodes 변화된 data
     */
    checkedTreeNodes (nodes) {
      if (nodes.length === 0) {
        this.paramOptions = []
        this.stepOptions = []
        this.summaryOptions = []
      } else {
        this.getMultipleParamList(nodes)
        this.getMultipleStepList(nodes)
        this.getSummaryDataMap(nodes)
      }
    },
    /**
     * selectedParamOptions 변화 감지
     * @param {*} selectedOptions 선택된 Parameter
     */
    selectedParamOptions (selectedOptions) {
      let filterOtions = selectedOptions.filter(option => option !== 'ALLCHECK')
      if (filterOtions.length === this.paramOptions.length &&
        !selectedOptions.includes('ALLCHECK')) {
        this.selectedParamOptions.unshift('ALLCHECK')
      } else if (filterOtions.length < this.paramOptions.length &&
        selectedOptions.includes('ALLCHECK')) {
        this.selectedParamOptions.shift()
      }
    },
    /**
     * selectedStepOptions 변화 감지
     * @param {*} selectedOptions 선택된 Step
     */
    selectedStepOptions (selectedOptions) {
      let filterOtions = selectedOptions.filter(option => option !== 'ALLCHECK')
      if (filterOtions.length === this.stepOptions.length &&
        !selectedOptions.includes('ALLCHECK')) {
        this.selectedStepOptions.unshift('ALLCHECK')
      } else if (filterOtions.length < this.stepOptions.length &&
        selectedOptions.includes('ALLCHECK')) {
        this.selectedStepOptions.shift()
      }
    },
    /**
     * selectedSummaryOptions 변화 감지
     * @param {*} selectedOptions 선택된 Summary Type
     */
    selectedSummaryOptions (selectedOptions) {
      let filterOtions = selectedOptions.filter(option => option !== 'ALLCHECK')
      if (filterOtions.length === this.summaryOptions.length &&
        !selectedOptions.includes('ALLCHECK')) {
        this.selectedSummaryOptions.unshift('ALLCHECK')
      } else if (filterOtions.length < this.summaryOptions.length &&
        selectedOptions.includes('ALLCHECK')) {
        this.selectedSummaryOptions.shift()
      }
    }
  },
  computed: {
  },
  methods: {
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     * EQP Tree 선택 시 Search Condition을 조회합니다. (Parameter, Step, Summary Type)
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Parameter combobox 조회
     * @param {Object} selectEqpVo EQP Tree node detail Object
     */
    // async getParamDataMap (selectEqpVo) {
    //   this.paramOptions = await API.FdcEqpInfo.paramNameList(selectEqpVo)
    //   this.paramSelectedIdx = 0
    // },
    /**
     * Step combobox 조회
     * @param {Object} selectEqpVo EQP Tree node detail Object
     * Recipe은 'ALL'로 조회합니다.
     */
    // async getStepDataMap (selectEqpVo) {
    //   selectEqpVo.recipeId = 'ALL'
    //   let stepOptionAll = await API.FdcEqpInfo.stepList(selectEqpVo)
    //   // step 중복 제거
    //   let stepList = stepOptionAll.reduce((unique, item) => {
    //     return unique.includes(item.stepId) ? unique : [...unique, item.stepId]
    //   }, [])
    //   this.stepOptions = stepList
    //   this.stepOptions = this.stepOptions.concat([ '99' ])
    //   // this.stepOptions = this.stepOptions.concat([{ stepId: '99' }])
    //   this.stepSelectedIdx = 0
    // },
    /**
     * Summary Type combobox 조회 (summary data plan에서 summary type 조회로 변경)
     * @param eqpList check된 eqp list
     */
    async getSummaryDataMap (eqpList) {
      // code에서 summary type 조회
      // this.summaryOptions = await API.FdcAnalysis.codeList('smryType')

      // summary data plan에서 summary type 조회
      let fabList = []
      let eqpIdList = []

      eqpList.forEach(node => {
        fabList.push(node.detail.fab)
        eqpIdList.push(node.detail.eqpId)
      })

      let obj = {
        fab: fabList + '',
        eqpId: eqpIdList + '',
        recipeId: 'ALL',
        useYn: 'Y'
      }
      this.summaryOptions = await API.Collection.getSummaryPlanTypesString(obj)
      this.summarySelectedIdx = 2
    },
    /**
     * EQP Tree 하위 node 정보 설정
     * @param {*} nodeList EQP Tree node
     * @param {Number} len EQP Tree node children length
     */
    // eqpNodeSelect (nodeList, len) {
    //   for (let i = 0; i < len; i++) {
    //     let node = nodeList[i]
    //     if (node.children.length && node.level !== 4) {
    //       this.eqpNodeSelect(node.children, node.children.length)
    //     } else {
    //       this.eqpList.push(node.title)
    //     }
    //   }
    // },
    /**
     * 검색 Validation
     * @returns {Boolean} valiation 성공 여부
     */
    validSearch () {
      if (this.paramOptions.length === 0 || this.selectedParamOptions.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Parameter']))
        return false
      }
      if (this.stepOptions.length === 0 || this.selectedStepOptions.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Step']))
        return false
      }
      if (this.summaryOptions.length === 0 || this.selectedSummaryOptions.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Summary Type']))
        return false
      }
      return true
    },
    /**
     * EQP Comparison 조회
     */
    searchBtn () {
      if (!this.validSearch()) {
        return
      }

      // let paramValue = this.paramOptions[this.paramSelectedIdx]
      // let stepValue = this.stepOptions[this.stepSelectedIdx]
      // let summaryType = this.summaryOptions[this.summarySelectedIdx]
      let selectedParamList = this.selectedParamOptions
      let selectedStepList = this.selectedStepOptions
      let selectedSummaryTypeList = this.selectedSummaryOptions
      // const node = this.selectedTreeNode.detail

      let eqpList = this.checkedTreeNodes
      let fabList = []
      let eqpIdList = []

      eqpList.forEach(node => {
        fabList.push(node.detail.fab)
        eqpIdList.push(node.detail.eqpId)
      })

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )
      // this.$commonUtil.setStoreEqpTree(
      //   this.selectedTreeNode,
      //   this.$refs.fdcEqpTree.treeType
      // )
      // this.eqpList = []
      // if (this.selectedTreeNode.children.length) {
      //   this.eqpNodeSelect(this.selectedTreeNode.children, this.selectedTreeNode.children.length)
      // } else {
      //   this.eqpList.push(this.selectedTreeNode.title)
      // }

      const payload = {
        fab: fabList, // list 형태로 변경
        eqpList: eqpIdList, // list 형태로 변경
        paramName: selectedParamList, // list 형태로 변경
        stepId: selectedStepList, // list 형태로 변경
        summaryType: selectedSummaryTypeList, // list 형태로 변경
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999',
        searchKind: 'EqpComparison'
      }
      this.searchData(payload)
    },
    /**
     * EQP Comparison 조회
     * @param {Object} payload 검색 조건 Object
     */
    async searchData (payload) {
      await API.Analysis.runEqpComparison(payload, this.callBack)
    },
    /**
     * EQP Comparison 조회 callback
     * @param {Object} response EQP Comparison 조회 결과
     */
    callBack (response) {
      let traces = response.data.map(data => {
        return {
          type: 'box',
          name: data.name,
          x: data.x,
          y: data.y,
          text: data.text,
          boxpoints: false,
          // boxpoints: 'all',
          hovertemplate: 'EQP Id: %{text.eqp}<br>Module Id: %{text.moduleId}<br>Parameter: %{text.paramName}<br>Step Id: %{text.stepId}<br>Summary Type: %{text.summaryType}<extra></extra>'
        }
      })

      let layout = {
        // boxmode: 'group'
        xaxis: {
          tickangle: 'auto'
        }
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }

      BriqueChart.newPlot('eqpComparisonChart', traces, layout, config)
    },
    // drawSeriesbyEqp () {
    //   this.eqpCompChart.beginUpdate()
    //   this.eqpCompChart.series.splice(0, this.eqpCompChart.series.length)
    //   // Eqp Id, Module Id, Parameter, Step Id, Summary Type, Mean, Max, P75, P50, P25, Min
    //   let self = this
    //   this.eqpCompChart.tooltip.content = function (hti) {
    //     // return `<b>${hti.name}</b> - <b> ${hti.x} </b></br>
    //     return `<b>EQP Id</b>: ${self.chartData[hti.pointIndex].eqp}</br>
    //       <b>Module Id</b>: ${self.chartData[hti.pointIndex].moduleId}</br>
    //       <b>Parameter</b>: ${self.chartData[hti.pointIndex].paramName}</br>
    //       <b>Step Id</b>: ${self.chartData[hti.pointIndex].stepId}</br>
    //       <b>Summary Type</b>: ${self.chartData[hti.pointIndex].summaryType}</br>
    //       <b>Max</b>: ${Math.round(hti.item.max * 10000) / 10000.0}</br>
    //       <b>P75</b>: ${Math.round(hti.item.thirdQuartile * 10000) / 10000.0}</br>
    //       <b>Mean</b>: ${Math.round(hti.item.mean * 10000) / 10000.0}</br>
    //       <b>Median</b>: ${Math.round(hti.item.median * 10000) / 10000.0}</br>
    //       <b>P25</b>: ${Math.round(hti.item.firstQuartile * 10000) / 10000.0}</br>
    //       <b>Min</b>: ${Math.round(hti.item.min * 10000) / 10000.0}</br>`
    //   }
    //   //      this.eqpCompChart.axisX.labels = false
    //   const boxP = new analytics.BoxWhisker({
    //     name: '',
    //     binding: 'summaryList', // element.eqpId
    //     groupWidth: 0.1,
    //     gapWidth: 0.2
    //   })
    //   this.eqpCompChart.series.push(boxP)
    //   this.eqpCompChart.endUpdate()
    // },
    /**
     * 차트 y축 영역 계산
     * @param {*} data chart data
     */
    // applyZoom (data) {
    //   let chart = this.eqpCompChart
    //   let yMin = 0; let yMax = 100; let margin = 0
    //   let yMaxs = data.map(function (o) { return o.max })
    //   let yMins = data.map(function (o) { return o.min })
    //   yMax = Math.max(...yMaxs)
    //   yMin = Math.min(...yMins)
    //   margin = (yMax - yMin) * 0.2

    //   chart.deferUpdate(() => {
    //     chart.axisY.max = yMax + margin
    //     chart.axisY.min = yMin - margin
    //   })
    // },
    /**
     * null 값 check
     * @param {*} value check value
     */
    isEmpty (value) {
      if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    /**
     * EQP Tree Check시 수행하는 method
     * @param {*} checkedNodes check된 tree node 배열
     */
    eqpTreeChecked (checkedNodes) {
      this.checkedTreeNodes = checkedNodes
    },
    /**
     * Parameter 목록 조회 (Summary Data Plan에 지정된 parameter만 조회로 변경)
     * @param eqpList check된 eqp list
     */
    async getMultipleParamList (eqpList) {
      let fabList = []
      let eqpIdList = []

      eqpList.forEach(node => {
        fabList.push(node.detail.fab)
        eqpIdList.push(node.detail.eqpId)
      })

      let obj = {
        fab: fabList + '',
        eqpId: eqpIdList + '',
        useYn: 'Y'
      }

      // Parameter 전체 조회 (summary data plan에 없는 param도 조회)
      // let response = await API.FdcEqpInfo.paramNameList(obj)

      // Summary Data Plan에 지정된 parameter만 조회
      let response = await API.Collection.getSummaryPlanParamsString(obj)
      this.paramOptions = response
    },
    /**
     * 모든 Parameter 선택
     */
    paramSelectAll () {
      if (this.selectedParamOptions.includes('ALLCHECK')) {
        let paramOptionList = ['ALLCHECK']
        paramOptionList.push(...this.paramOptions)
        this.selectedParamOptions = paramOptionList
      } else {
        this.selectedParamOptions = []
      }
    },
    /**
     * 모든 step 선택
     */
    stepSelectAll () {
      if (this.selectedStepOptions.includes('ALLCHECK')) {
        let stepOptionList = ['ALLCHECK']
        stepOptionList.push(...this.stepOptions)
        this.selectedStepOptions = stepOptionList
      } else {
        this.selectedStepOptions = []
      }
    },
    /**
     * 모든 Summary Type 선택
     */
    summaryTypeSelectAll () {
      if (this.selectedSummaryOptions.includes('ALLCHECK')) {
        let summaryOptionList = ['ALLCHECK']
        summaryOptionList.push(...this.summaryOptions)
        this.selectedSummaryOptions = summaryOptionList
      } else {
        this.selectedSummaryOptions = []
      }
    },
    /**
     * Step 목록 조회 (중복제거) (Summary Data Plan에 지정된 Recipe-Step만 조회로 변경)
     * @param eqpList check된 eqp list
     */
    async getMultipleStepList (eqpList) {
      let fabList = []
      let eqpIdList = []

      eqpList.forEach(node => {
        fabList.push(node.detail.fab)
        eqpIdList.push(node.detail.eqpId)
      })

      let obj = {
        fab: fabList + '',
        eqpId: eqpIdList + '',
        recipeId: 'ALL',
        useYn: 'Y'
      }
      // 전체 step 조회
      // let response = await API.FdcEqpInfo.stepListForEqps(obj)
      // this.stepOptions = response.concat([ '99' ])
      // Summary Data Plan에 지정된 Recipe-Step만 조회
      let response = await API.Collection.getSummaryPlanRecipesString(obj)
      this.stepOptions = response
      this.stepSelectedIdx = 0
    }
  },
  data () {
    const dateString = new Date().toDateString()
    let fromDt = new Date(Dayjs(dateString).add(-1, 'day').format('YYYY.MM.DD'))
    let toDt = new Date()
    return {
      selectedTreeNode: [], // 선택된 EQP Tree node
      checkedTreeNodes: [], // 체크된 EQP Tree node
      chartData: [{ eqp: '', summaryList: [] }], // EQP Comparison chart data
      rotated: false, // chart option rotated
      // showMeanLine: false,
      // showMeanMarker: false,
      // showInnerPoints: false,
      // showOutliers: false,
      fromDate: fromDt, // From Date (condition)
      toDate: toDt, // To Date (condition)
      fromMaxDate: toDt, // From Date Max value
      fromMinDate: null, // From Date Min value
      toMaxDate: toDt, // To Date Max value
      toMinDate: fromDt, // To Date Min value
      paramOptions: [], // Parameter Combobox
      selectedParamOptions: [], // Selected Parameter
      stepOptions: [], // Step Combobox
      selectedStepOptions: [], // Selected Step ID
      summaryOptions: [], // Summary Type Combobox
      selectedSummaryOptions: [], // Selected Summary Type
      paramSelectedIdx: 0, // Parameter Combobox select index
      stepSelectedIdx: 0, // Step Combobox select index
      summarySelectedIdx: 0, // Summary Combobox select index
      // chartSerise: [],
      eqpList: [], // EQP 목록 (condition)
      palette: [
        'rgba(211, 211, 211, .8)',
        'rgba(81, 109, 136, .8)'
      ], // Chart Palette 배열
      yMin: null, // Chart y축 Min value
      yMax: null // Chart y축 Max value
    }
  }
}
